// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pd9WSqMXe8r7HjQDLYmQ {
  background: var(--grey-color-10);
  padding: 32px;
}

.ppseV2m71wBdfk3ZryWy {
  position: absolute;
  top: 6px;
  left: 6px;
}

.DBMD8O7qDt4142VuatFb {
  margin-right: 4px;
}

.psi5yryaObsfmZt5_7K0 {
  background-color: var(--background-color);
  padding: 16px 32px;
  border-radius: 10px;
}

.uoZor4s_EAZYAsJj6Wrg {
  width: 100%;
  display: flex;
  gap: 8px;
}

.sXmElHulwHKafYxW6YRw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  margin-bottom: 20px;
  margin-right: 45px;
}

.U2eLL1OZmgIxaX84r_P5 {
  display: inline-flex;
  gap: 16px;
  align-items: center;
  margin-right: 32px;
}

.BkDqn_cUBYmNG80bfDex {
  display: flex;
  align-items: center;
  gap: 8px;
}

.doTbmhDlLPgtnedBD5og {
  display: block;
}

.tPGxnLvhebtqKWQ6j3WU {
  color: var(--grey-color-70);
  font-family: var(--font-stack-full-medium);
  font-size: 16px;
  font-weight: 800;
  font-style: normal;
  line-height: 24px;
}

.rkClO4a7FgxIoHeB6vfQ {
  display: flex;
  gap: 40px;
  background-color: var(--grey-color-10);
  margin: 16px 0;
  padding: 16px 0;
  border-radius: 10px;
}

.vh5Ylyp6IGlIcz9izn_0 {
  flex: 3;
  background-color: var(--background-color);
  padding: 32px;
  border-radius: 10px;
}

.dDJ7s6kK6kflJCoHnQqX {
  margin-top: 100px;
}

.QaAPjKDZekL9tRqk49OX {
  flex: 7;
  background-color: var(--background-color);
  padding: 32px;
  border-radius: 10px;
}

.ETUD5ecy2sTn238bIr2z {
  flex: 3;
  background-color: var(--background-color);
  padding: 4px 32px 32px 32px;
  border-radius: 10px;
  width: 100%;
}

.chuZmrFHt7jhwAAYy2Kp {
  margin-top: 32px;
}

.w1IpjoUU8HCbtK4pqCox {
  background-color: var(--background-color);
  margin-top: 32px;
  border-radius: 10px;
  padding: 32px;
}

.V4cWeY3jhxACTqViZTNe {
  font-family: var(--font-stack-full-medium);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
  display: flex;
  justify-content: space-between;
}

.F5W6l3erl3qT6o5QS6MV {
  height: 1px;
  margin: 16px 0;
  background-color: var(--grey-color-200);
}

.YOkplT48kvziSISRS5Gp {
  display: grid;
  grid-template-columns: 0.5fr 1fr 1fr;
  margin-top: 24px;
  gap: 32px;
}

.HIglkYKKI6LtIPAUVS7q, .og9VAipJ4ixpC3K7fXHG {
  font-family: var(--font-stack-full-medium);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
}

.jDumk_UlDKdL7Fazxz3s {
  display: flex;
  justify-content: space-between;
  margin-left: 5px;
}

.hxFZo2KdlOY4YaGTEc0g {
  display: flex;
  align-items: center;
}

.og9VAipJ4ixpC3K7fXHG {
  margin-left: 14px;
}

.AUrlUwoIq_M976guo0Dk {
  margin-top: 12px;
}

.CPn3OEe79y22Ju8BVTIA {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
}

.Nqdmf5VjlSrDKRYaG7HR {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  background-color: var(--grey-color-10);
  border-radius: 12px;
}

.p8KUsIeescU7rU_1dxJt {
  font-family: var(--font-stack-full-regular);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--grey-color-90);
}

.bPpvqVrscJpCaQcJWS3I {
  color: var(--grey-color-90);
  background-color: #cccccc;
  border-radius: 50%;
}

.JZ7hpEPzGwRPx9xo7zZV {
  height: 16px;
  margin-right: 8px;
}

.iLBTdkX1yKXDmd9k7Ia1 {
  margin-right: 8px;
  border-radius: 50%;
  box-shadow: none;
}

.iLBTdkX1yKXDmd9k7Ia1:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/CohortSkillGroupV2/CohortSkillGroupV2.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,2BAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,sCAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,SAAA;AACF;;AAEA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,2BAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,sCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,2BAAA;EACA,yBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;AAAF","sourcesContent":[".container {\n  background: var(--grey-color-10);\n  padding: 32px;\n}\n\n.barChartTitle {\n  position: absolute;\n  top: 6px;\n  left: 6px;\n}\n\n.projectName {\n  margin-right: 4px;\n}\n\n.levelledLegendContainer {\n  background-color: var(--background-color);\n  padding: 16px 32px;\n  border-radius: 10px;\n}\n\n.innerHeatmapContainer {\n  width: 100%;\n  display: flex;\n  gap: 8px;\n}\n\n.heatmapTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  margin-bottom: 20px;\n  margin-right: 45px;\n}\n\n.legendContainer {\n  display: inline-flex;\n  gap: 16px;\n  align-items: center;\n  margin-right: 32px;\n}\n\n.legendItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.legendImage {\n  display: block;\n}\n\n.legendText {\n  color: var(--grey-color-70);\n  font-family: var(--font-stack-full-medium);\n  font-size: 16px;\n  font-weight: 800;\n  font-style: normal;\n  line-height: 24px;\n}\n\n.chartContainer {\n  display: flex;\n  gap: 40px;\n  background-color: var(--grey-color-10);\n  margin: 16px 0;\n  padding: 16px 0;\n  border-radius: 10px;\n}\n\n.piChartContainer {\n  flex: 3;\n  background-color: var(--background-color);\n  padding: 32px;\n  border-radius: 10px;\n}\n\n.donutChartInner {\n  margin-top: 100px;\n}\n\n.barChartContainer {\n  flex: 7;\n  background-color: var(--background-color);\n  padding: 32px;\n  border-radius: 10px;\n}\n\n.heatmapContainer {\n  flex: 3;\n  background-color: var(--background-color);\n  padding: 4px 32px 32px 32px;\n  border-radius: 10px;\n  width: 100%;\n}\n\n.heatmap {\n  margin-top: 32px;\n}\n\n.scoringFactorContainer {\n  background-color: var(--background-color);\n  margin-top: 32px;\n  border-radius: 10px;\n  padding: 32px;\n}\n\n.scoringFactorTitle {\n  font-family: var(--font-stack-full-medium);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n  display: flex;\n  justify-content: space-between;\n}\n\n.scoringFactorDividerLine {\n  height: 1px;\n  margin: 16px 0;\n  background-color: var(--grey-color-200);\n}\n\n.averageDistributionTitleContainer {\n  display: grid;\n  grid-template-columns: 0.5fr 1fr 1fr;\n  margin-top: 24px;\n  gap: 32px;\n}\n\n.averageAndDistributionLabel {\n  font-family: var(--font-stack-full-medium);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n}\n\n.averageScoreAndArrowIconContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-left: 5px;\n}\n\n.arrowIconContainer {\n  display: flex;\n  align-items: center;\n}\n\n.distributionScoreTitle {\n  margin-left: 14px;\n  @extend .averageAndDistributionLabel;\n}\n\n.factorScoringMainContainer {\n  margin-top: 12px;\n}\n\n.targetText {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.targetErrorMessageContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px;\n  background-color: var(--grey-color-10);\n  border-radius: 12px;\n}\n\n.targetErrorMessage {\n  font-family: var(--font-stack-full-regular);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--grey-color-90);\n}\n\n.infoIconStyle {\n  color: var(--grey-color-90);\n  background-color: #cccccc;\n  border-radius: 50%;\n}\n\n.normImage {\n  height: 16px;\n  margin-right: 8px;\n}\n\n.aboveNormCircleImage {\n  margin-right: 8px;\n  border-radius: 50%;\n  box-shadow: none;\n}\n\n.aboveNormCircleImage:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Pd9WSqMXe8r7HjQDLYmQ`,
	"barChartTitle": `ppseV2m71wBdfk3ZryWy`,
	"projectName": `DBMD8O7qDt4142VuatFb`,
	"levelledLegendContainer": `psi5yryaObsfmZt5_7K0`,
	"innerHeatmapContainer": `uoZor4s_EAZYAsJj6Wrg`,
	"heatmapTitle": `sXmElHulwHKafYxW6YRw`,
	"legendContainer": `U2eLL1OZmgIxaX84r_P5`,
	"legendItem": `BkDqn_cUBYmNG80bfDex`,
	"legendImage": `doTbmhDlLPgtnedBD5og`,
	"legendText": `tPGxnLvhebtqKWQ6j3WU`,
	"chartContainer": `rkClO4a7FgxIoHeB6vfQ`,
	"piChartContainer": `vh5Ylyp6IGlIcz9izn_0`,
	"donutChartInner": `dDJ7s6kK6kflJCoHnQqX`,
	"barChartContainer": `QaAPjKDZekL9tRqk49OX`,
	"heatmapContainer": `ETUD5ecy2sTn238bIr2z`,
	"heatmap": `chuZmrFHt7jhwAAYy2Kp`,
	"scoringFactorContainer": `w1IpjoUU8HCbtK4pqCox`,
	"scoringFactorTitle": `V4cWeY3jhxACTqViZTNe`,
	"scoringFactorDividerLine": `F5W6l3erl3qT6o5QS6MV`,
	"averageDistributionTitleContainer": `YOkplT48kvziSISRS5Gp`,
	"averageAndDistributionLabel": `HIglkYKKI6LtIPAUVS7q`,
	"distributionScoreTitle": `og9VAipJ4ixpC3K7fXHG`,
	"averageScoreAndArrowIconContainer": `jDumk_UlDKdL7Fazxz3s`,
	"arrowIconContainer": `hxFZo2KdlOY4YaGTEc0g`,
	"factorScoringMainContainer": `AUrlUwoIq_M976guo0Dk`,
	"targetText": `CPn3OEe79y22Ju8BVTIA`,
	"targetErrorMessageContainer": `Nqdmf5VjlSrDKRYaG7HR`,
	"targetErrorMessage": `p8KUsIeescU7rU_1dxJt`,
	"infoIconStyle": `bPpvqVrscJpCaQcJWS3I`,
	"normImage": `JZ7hpEPzGwRPx9xo7zZV`,
	"aboveNormCircleImage": `iLBTdkX1yKXDmd9k7Ia1`
};
export default ___CSS_LOADER_EXPORT___;
